module.exports = __webpack_public_path__ + "img/phantom-assasin.71ef99dd.png";